import { useId } from "react";

/**
 * Mini-courbe de performance des cartes de la liste.
 * points : tableau de valeurs (indice base 10 000), envoyé par le serveur dans `spark`.
 */
export default function PortfolioSparkline({ points = [], up = true, className = "w-full h-16" }) {
  const gid = useId().replace(/:/g, "");
  if (!points || points.length < 2) {
    return (
      <div className={`${className} grid place-items-center text-[11px] text-zinc-600 border border-dashed border-white/5 rounded-lg`}>
        Historique en cours de constitution
      </div>
    );
  }
  const W = 300;
  const H = 64;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const d = points
    .map((v, i) => {
      const x = (i / (points.length - 1)) * W;
      const y = H - 4 - ((v - min) / span) * (H - 8);
      return `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(" ");
  const color = up ? "0,191,99" : "251,113,133";
  return (
    <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={`rgb(${color})`} stopOpacity="0.25" />
          <stop offset="1" stopColor={`rgb(${color})`} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${d} L${W},${H} L0,${H} Z`} fill={`url(#${gid})`} />
      <path d={d} fill="none" stroke={`rgb(${color})`} strokeWidth="1.6" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
